import './App.css';

 import {ContextProvider} from "./context/context";

 import Header from './components/header/header';
 import Main from './components/main/main';
 import Footer from './components/footer/footer';
 import Modal from './components/modal/modal';

function App() {
  return (
    <div className="App">
      <ContextProvider>
        <Header />
        <Main />
        <Footer />
        <Modal />
      </ContextProvider>
    </div>
  );
}

export default App;
